import { render, staticRenderFns } from "./PacksList.vue?vue&type=template&id=53e3b5a8&"
import script from "./PacksList.vue?vue&type=script&lang=js&"
export * from "./PacksList.vue?vue&type=script&lang=js&"
import style0 from "./PacksList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports